// Sezioni "lite" (palette awrabet/koba) della home mobile di gojjobet: TopLeagues, TopWidget, LiveEvents.
// Stessa struttura di jamibet/mobile-pages/home.jsx, colori gojjo-lite e template/componenti lite.
import { h, Fragment } from "preact";
import { useState } from "preact/hooks";
import { route } from "preact-router";
import { Trans } from "@lingui/react/macro";

import PFeed from "../../../services/prematch-feed";
import SchedulesTimeFilter from "../../jamibet/utils/schedules-time-filter";

import * as D from "./templates-card-header.jsx";
import * as P from "./templates-sports.jsx";
import { TournamentCard, WrappedPrematchTournamentPage } from "./prematch.jsx";
import { TodayWidget } from "./today-widget.jsx";
import { Tournament } from "./live-tournament.jsx";

import {
	MobileLiveEvents as AwrabetMobileLiveEvents,
	MobileTopLeagues as AwrabetMobileTopLeagues,
} from "../../awrabet/mobile-pages/home";

export class MobileTopLeagues extends AwrabetMobileTopLeagues {
	render() {
		if (this.state.topLeagues.length == 0)
			return null;

		return <div>
			<D.CardHeaderRow>
				<D.ThreeDots />
				<D.TournamentSportName><Trans>Top Leagues</Trans></D.TournamentSportName>
			</D.CardHeaderRow>
			<div class="flex overflow-x-auto gap-2 p-2 bg-gojjo-lite-200">
				{this.state.topLeagues.map(tournament => PFeed.getWithParents(tournament.id)).map(({ tournament, category }) => (
					<div
						class={"flex shrink-0 items-center text-gojjo-lite-950 gap-2 rounded-md border border-gojjo-lite-300 px-2 py-1 text-sm " + (this.isCurrent(tournament) ? 'bg-gojjo-lite-100' : 'bg-gojjo-lite-200')}
						onClick={e => this.setTournament(tournament)}
					>
						<P.TournamentIcon tournament={tournament} class={"h-5 w-5 league-" + category.name.toLowerCase().replace(/ /g, '') + tournament.name.toLowerCase().replace(/ /g, '')} />
						<span class="inline-block min-w-0 flex-1 truncate">{tournament.name}</span>
					</div>
				))}
			</div>
			{this.state.currentTournamentId && <WrappedPrematchTournamentPage key={this.state.currentTournamentId} tournamentId={this.state.currentTournamentId}>
				{({ tournament }) => <Fragment>
					<TournamentCard tournamentCard={tournament} minEvents={this.state.isShowMore ? Infinity : 5} />
					{this.state.isShowMore ? null : <div class="p-4 text-center">
						<button
							onClick={e => this.setState({isShowMore: true})}
							class="bg-gojjo-gold-lite-500 text-gojjo-lite-950 px-6 py-2 rounded uppercase"
						>
							<Trans>Show More</Trans>
						</button>
					</div>}
				</Fragment>}
			</WrappedPrematchTournamentPage>}
		</div>
	}
}

export function MobileTopWidget() {
	if (!PFeed.menu)
		return null;

	const [sportId, setSportId] = useState("/sport/1");

	const sortedSportsList = Object.values(PFeed.menu).sort((a, b) => a.order - b.order);

	return <div>
		<P.SportsHolder>
			{sortedSportsList
				.filter(s => SchedulesTimeFilter.isScheduleAllowed(s))
				.map(sport => ({...sport, count: countTodayEventsInSport(sport.id)}))
				.filter(s => s.count > 0)
				.slice(0, 10)
				.map(sport =>
					<P.SportButton
						active={sport.id == sportId}
						sport={sport}
						onClick={e => setSportId(sport.id)}
					/>
				)}
		</P.SportsHolder>
		<D.CardHeaderRow>
			<D.ThreeDots />
			<D.TournamentSportName>
				<Trans>Today</Trans>
				<span class="pl-2 text-gojjo-gold-lite-600">{countTodayEventsInSport(sportId)}</span>
			</D.TournamentSportName>
		</D.CardHeaderRow>
		<TodayWidget sport={PFeed.menu[sportId]} />
	</div>
}

export function countTodayEventsInSport(sportId) {
	if (!PFeed.menu)
		return 0;

	const sport = PFeed.menu[sportId];
	if (!sport)
		return 0;

	const now = new Date();
	const endOfDay = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59, 999).getTime();
	const msUntilMidnight = endOfDay - now.getTime();
	const hoursUntilMidnight = msUntilMidnight / (1000 * 60 * 60);

	if (hoursUntilMidnight > 8) {
		return sport["filter-count"]?.['24h'] || 0;
	}

	if (hoursUntilMidnight > 3) {
		return Object.keys(sport["next-list"]?.["8hour"] || {}).length;
	}

	if (hoursUntilMidnight > 1) {
		return Object.keys(sport["next-list"]?.["3hour"] || {}).length;
	}

	return Object.keys(sport["next-list"]?.["1hour"] || {}).length;
}

export class MobileLiveEvents extends AwrabetMobileLiveEvents {
	render() {
		return <div>
			<D.CardHeaderRow>
				<D.ThreeDots />
				<D.TournamentSportName><Trans>Live</Trans></D.TournamentSportName>
			</D.CardHeaderRow>
			{this.getCurrentSport() && this.getCategories().map(tournament =>
				<Tournament key={tournament.id} tournament={tournament} />
			)}
		</div>
	}
}
